/**
 * vant 有赞UI组件
 *
 * @Author  Yee
 * @DATE    create on 2019/7/3
 * @DESC
 */
import Vue from 'vue'
import {
  Button,
  ActionSheet,
  Toast,
  Skeleton,
  Dialog,
  Tab,
  Tabs,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  PullRefresh,
  Uploader,
  Field,
  List,
  Cell,
  Icon,
  Swipe,
  SwipeItem,
  Loading,
  RadioGroup,
  Radio,
  overlay,
} from 'vant'

// options 为可选参数，无则不传
Toast.setDefaultOptions({
  duration: 1500
})

Vue.use(Checkbox).use(CheckboxGroup);
Vue.use(Tab).use(Tabs)
Vue.use(PullRefresh)
Vue.use(Button)
Vue.use(Popup)
Vue.use(DatetimePicker)
Vue.use(ActionSheet)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Skeleton)
Vue.use(Uploader)
Vue.use(Field)
Vue.use(List)
Vue.use(Cell)
Vue.use(Icon)
Vue.use(Swipe).use(SwipeItem)
Vue.use(Loading)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(overlay)

